import { CSSProperties, StyleSheet } from 'aphrodite';
import { titles } from '../../../../web/styles/colors';
import { baseStyles } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		display: 'flex',
		margin: '20px 0',
		maxWidth: 350,
	},
	industryName: {
		color: titles,
		display: 'block',
		fontSize: 14,
		paddingBottom: 2,
		paddingLeft: 10,
		width: 133,
	},
	select: {
		...(baseStyles.textField as CSSProperties),
		height: 40,
		minWidth: 200,
	},
	selectContainer: {
		marginLeft: 120,
	},
	selectMenu: {
		minWidth: 200,
	},
});
